// bao migrate skip
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-number-box";
import "./../../services/bao-menu";
import "./../../bindings/validate";
import "./../../bindings/sorting";
import "./../../bindings/foreach-selection";
import "./../../services/bao-router";
import "./../../bindings/bao-searcher";
import "./../../bindings/filtering";
import "./../../bindings/bao-upload";
import BaseViewModel from "./../../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
import Guid from "./../../factories/guid";
class ConfigurationItem100WorkPeriodDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    public Model: any;
    EntryDate = ko.observable();
    EntryDateJs = ko.observable();
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
    }
}
export default ConfigurationItem100WorkPeriodDialog;